import { Component, Input } from '@angular/core';

@Component({
  selector: 'wl-receipt-breakdown-row',
  templateUrl: './receipt-breakdown-row.component.html',
  styleUrls: [
    './receipt-breakdown-row.component.ed.scss',
    './receipt-breakdown-row.component.essent.scss',
  ],
  standalone: true,
})
export class ReceiptBreakdownRowComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() separator = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) hasRightPart!: boolean | null;
}
